<template>
  <v-menu close-on-content-click
          open-on-hover offset-y
          close-delay="300">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="normal-btn-text body-1 font-weight-bold ml-3"
        v-on="on"
      >
        Cadastros
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras && !hasRoleComprador"
        to="/fornecedores"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-account-check-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Fornecedores</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras && !hasRoleComprador"
        to="/fornecedores-gestao-grupos"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-account-multiple-check-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Grupos de fornecedores</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
      link
      :disabled="!hasRoleGestorCompras && !hasRoleCadastroProduto"
        to="/tipos-uso"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-shape-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Tipos de uso</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
      link
      :disabled="!hasRoleGestorCompras && !hasRoleCadastroProduto"
        to="/categorias"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-view-grid</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Categorias</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras && !hasRoleCadastroProduto"
        to="/produtos"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-package-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Meus produtos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras && !hasRoleCadastroProduto"
        to="/unidades-medidas"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-beaker-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Unidades de medida</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras"
        to="/modos-pagamento"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-cash-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Modos de pagamento</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras"
        to="/centros-custo"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-puzzle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Centros de custo</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="(!hasRoleGestorCompras)"
        to="/projetos"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-folder-table-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Projetos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras && !hasRoleComprador"
        to="/locais-entrega"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-map-marker</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Locais de entrega</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras"
        to="/tabelas-preco"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-table</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Tabelas de preço</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras"
        to="/configuracoes-nota-entrada"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-invoice-list-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Notas de Entrada</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleGestorCompras"
        to="/mensagens"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-message-text-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Mensagens personalizadas
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['hasRoleGestorCompras', 'hasRoleRequisicao', 'hasRoleCadastroProduto', 'hasRoleComprador']),
  },
};
</script>
